function i(r, n, t) {
  return Math.round((r - n) / t) * t + n;
}
function m(r, n, t) {
  return Math.min(Math.max(r, n), t);
}
function a(r, n, t) {
  return (r - n) / (t - n);
}
function f(r, n, t, e) {
  const o = r * (t - n) + n, u = i(o, n, e);
  return m(u, n, t);
}
function x(r, n) {
  const t = { min: r[0], max: r[1] }, e = { min: n[0], max: n[1] };
  return function(u) {
    if (t.min === t.max || e.min === e.max) return e.min;
    const c = (e.max - e.min) / (t.max - t.min);
    return e.min + c * (u - t.min);
  };
}
export {
  m as clampValue,
  f as getPercentValue,
  i as getRoundedValue,
  a as getValuePercent,
  x as getValueTransformer
};
